import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    OnDestroy,
    OnInit,
    ViewChild
} from '@angular/core';
import { DraftFacade } from '@classifieds-sell/state';
import { DelayService } from '@trademe/tangram';
import { BehaviorSubject, Subject } from 'rxjs';
import { StepIds } from '../../../models/property-step/property-step-model';

import { PropertySectionBase } from '../../property-section-base';

@Component({
    selector: 'property-summary-page-description-field',
    templateUrl: './summary-page-description-field.component.html',
    styleUrls: ['./summary-page-description-field.component.scss']
})
export class SummaryPageDescriptionFieldComponent
    extends PropertySectionBase
    implements OnInit, OnDestroy, AfterViewInit {
    stepIds = StepIds;
    @ViewChild('descriptionElement', { static: true })
    descriptionElement: ElementRef;

    /* a hacky solution for ellipsis (especially to be able to work on IE 11) */
    maxLines = 5;
    isMoreThanMaxLines$ = new BehaviorSubject<boolean>(false);
    showAll$ = new BehaviorSubject<boolean>(true);

    description: string;

    private _destroyed$: Subject<void> = new Subject<void>();

    constructor(
        draftFacade: DraftFacade,
        private _changeDetectorRef: ChangeDetectorRef,
        private _delayService: DelayService
    ) {
        super(draftFacade);
    }

    ngOnDestroy(): void {
        super.onDestroy();
        this._destroyed$.next();
    }

    ngOnInit(): void {
        super.onInit(() => {
            this.description = this.draftData.propertyDescription.description;
            this._changeDetectorRef.markForCheck();
        });
    }

    ngAfterViewInit() {
        /* a hacky solution for ellipsis (especially to be able to work on IE 11) */
        const descriptionHeight =
            this.descriptionElement.nativeElement.offsetHeight;
        const descriptionLineHeight = parseInt(
            getComputedStyle(
                this.descriptionElement.nativeElement
            ).getPropertyValue('line-height'),
            10
        );
        const descriptionLines = descriptionHeight / descriptionLineHeight;
        const isMoreThanMaxLines = descriptionLines > this.maxLines;
        this.isMoreThanMaxLines$.next(isMoreThanMaxLines);
        this.showAll$.next(!isMoreThanMaxLines);

        // delaying in event loop to make sure template gets the updates
        this._delayService.createDelay(0).subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }

    isValid(): boolean {
        return true;
    }

    dirty(): boolean {
        return false;
    }

    onShowMore() {
        this.showAll$.next(!this.showAll$.value);
    }
}
